/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState, useCallback } from 'react'
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId'
import { dataService } from '../../../../../services/data.services'
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick'
import Debounce from '../../../../../CommonMethods/Debounce'

export default function SearchItemField({
    handleSearchFiled,
    index,
    newStateFields,
    setNewStateFields,
    submitSelected,
    selectedErrorState,
    setSelectedErrorState,
    setToastErrorMessage,
    divClassName,
    endPointSearch,
    placeHolderValue,
    ShimmerTitle,
    noItemMsg,
    invoices
}) {
    const inputRef=useRef()
    const [itemListData,setItemListData]=useState([])
    const [showItemsDropdownData,setShowItemsDropdownData]=useState(false)
    const [itemSearchStarted,setItemSearchStarted]=useState(false)
    useOnClickOutside(inputRef, () => {
        setItemListData([]);
        setShowItemsDropdownData(false)  
        setItemSearchStarted(false)
    });

    const handelSearchInput = useCallback(
        Debounce((key, value) => handelSearchInputDebounce(key,value)),
        []
    );
    
    const handelSearchInputDebounce = (value) => {
        const timer=setTimeout(async ()=>{
            setItemSearchStarted(true)
            let searchValue = encodeURIComponent(value).replace(/[#&]/g, '\\$&').trim()
            // let copy = copyParams.delete("fy_status")
            if(searchValue.trim() !== "") {   
                try{
                    const branch_id = await GetBranchId()
                    const res = await dataService.GetAPI(`inventory?branch_id=${branch_id}&role=${invoices ? 'invoices' : 'purchase-order'}&search=${searchValue}&filter=true&status=active${endPointSearch !== undefined ? endPointSearch : `&opening_balance=false`}`, true);
                    setItemListData(res.data.data.data)
                    setShowItemsDropdownData(true)

                }catch(error){
                    console.log("error", error)
                    setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                }
            }else{
                setItemListData([])
                setShowItemsDropdownData(false)
                setItemSearchStarted(false)
            }
        },500)
        return()=>{
            clearTimeout(timer)
        }
    }
    return (
        <div className={divClassName !== undefined ? divClassName : `w-[24%] px-2`}>
            <div class="relative w-full" ref={inputRef}>
                <label for="input"></label>
                <input 
                    type="text" 
                    id="item_name"
                    autoComplete='off'
                    className={` ${(submitSelected && newStateFields[index].item_name === "" || selectedErrorState === index) ? "redBorder" : ""} inpt-fld w-full error_border`} 
                    placeholder={placeHolderValue !== undefined ? placeHolderValue : `Search by Name/code`} 
                    onChange={e=>{
                        let updatedClassFields = [...newStateFields];
                        updatedClassFields[index]["item_name"] = e.target.value;
                        setNewStateFields([...updatedClassFields]);
                        handelSearchInput(e.target.value)
                        setSelectedErrorState(null)
                        setToastErrorMessage("")
                    }}
                    value={newStateFields[index].item_name} 
                />
                {itemSearchStarted && (
                    <ul className="slct_drp_dwn min-w-full select_student" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref>
                        <li className="max-h-[150px] overflow-auto scroll-bar">
                            {showItemsDropdownData ? (
                                itemListData?.length === 0 ? (
                                    <ul>
                                        <li>
                                            <a
                                                onClick={() => { }}
                                                className="selected_Class"
                                                href="#"
                                                data-te-dropdown-item-ref
                                            >
                                                {noItemMsg}
                                            </a>
                                        </li>
                                    </ul>
                                ) : (
                                    itemListData?.map((item)=>(
                                        <ul key={item}>
                                            <li>
                                                <a
                                                    class="slct_drp_dwn_optn selected_Class" 
                                                    onClick={() => {handleSearchFiled(index, item); setItemListData([]); setShowItemsDropdownData(false); setItemSearchStarted(false);}} 
                                                >{item.item_name} {`(${item.item_code})`}
                                                </a>
                                            </li>
                                     
                                        </ul>
                                    ))
                                )
                            ) : (
                                <li className="max-h-[150px] overflow-auto scroll-bar" style={{ 'padding': '0.3rem 0.5rem' }}>
                                    <p className="text-2xl font-bold text-[#031624] mb-2 mt-2"><ShimmerTitle line={1} gap={6} variant="secondary" /></p>
                                </li>
                            )}
                        </li>
                    </ul>
                )}
            </div>
        </div> 
    )
}
